
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function HeaderSearch({ baseUrl }) {
  const [isInputOpen, setInputOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchClick = (e) => {
    e.preventDefault();
    setInputOpen(true);
  };

  const handleOnChangeInput = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    isInputOpen ? (
      <form className="header-search" method="GET" action={baseUrl} role="search">
        <label htmlFor="search">
          <span className="screen-reader-text">
            Search
          </span>
          <input
            className="header-search__input"
            type="search"
            name="s"
            placeholder="Search"
            onChange={handleOnChangeInput}
            value={searchQuery}
          />
        </label>
        <button
          aria-label="submit"
          type="submit"
          className="site-header__submit"
        />
      </form>
    ) : (
      <button
        aria-label="Search"
        onClick={handleSearchClick}
        type="button"
        className="site-header__search"
      />
    )
  );
}

HeaderSearch.propTypes = {
  baseUrl: PropTypes.string,
};

HeaderSearch.defaultProps = {
  baseUrl: '',
};
